export type H5JumpInfo = {
  /** 跳转H5链接 */
  jumpUrl?: string;
};

export type MiniAppJumpInfo = {
  /** 拉起小程序，AppID，账号原始ID和AppID二选一即可 */
  appid?: string;
  /** 拉起小程序，账号原始ID，账号原始ID和AppID二选一即可 */
  username?: string;
  /** 拉起小程序，页面路径, 不填则默认跳转小程序主页 */
  path?: string;
};

export type MultiJumpInfo = H5JumpInfo & MiniAppJumpInfo;

export enum MultiJumpType {
  'Mp' = 'MP',
  'H5' = 'H5',
  'Other' = 'Other',
}
